/**
 * Selection 계층: 행 선택을 소비처 `onSelect`로 전달하는 단일 seam. 본체의 primary click과
 * navigation 계층의 이동이 같은 `select(entry, reason)`를 호출하므로 `detail` 조립은 여기 한 곳이다.
 */
import { useCallback } from "react";

import type { ListViewEntry } from "./useListViewCollections";

/**
 * `onSelect`가 불린 원인. selection-follows-focus라 방향키 이동도 선택이지만, 클릭·Enter·Space는
 * 선택이면서 확정이기도 하다. 즉시 확정 picker나 재클릭 해제 같은 확정 정책은 소비처가
 * `activation`에서만 적용한다.
 */
export type ListViewSelectReason = "navigation" | "activation";

export type ListViewSelectDetail = {
  readonly reason: ListViewSelectReason;
};

export type ListViewSelectHandler<T> = (
  item: T,
  index: number,
  detail: ListViewSelectDetail,
) => void;

export type ListViewSelect<T> = (entry: ListViewEntry<T>, reason: ListViewSelectReason) => void;

export function useListViewSelection<T>(onSelect: ListViewSelectHandler<T>): ListViewSelect<T> {
  return useCallback<ListViewSelect<T>>(
    (entry, reason) => onSelect(entry.item, entry.index, { reason }),
    [onSelect],
  );
}
